<template>
  <DatatableReportV3
    id="admins-table"
    ref="admins_table"
    class="p-2"
    title="Admin Users"
    :config="config"
    :source="props.source"
    :filters="props.filters"
    no-download
  >
    <template #actions>
      <SeraButton
        icon="fa fa-plus fa-fw"
        text="Add Admin"
        @click="handleClickAddAdmin"
      />
    </template>
  </DatatableReportV3>
</template>

<script setup lang="ts">
import { defineProps, ref } from "vue";

import SeraButton from "@/components/Button.vue";
import { adminCreatePath } from "@/mixins/path_helpers.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

// Define props
const props = defineProps({
  source: {
    type: String,
    default: ""
  },
  filters: {
    type: Array,
    default: () => []
  }
});

// Define static config object
const config = {
  pageLength: 25,
  order: [[0, "asc"]],
  columns: [
    { data: "name" },
    { data: "email" },
    {
      data: "role",
      title: "Access Level",
      filterName: "role"
    },
    {
      data: "receives_emails",
      title: "Receives Email?",
      filterName: "receives_emails"
    }
  ]
};

// Define action handlers
const handleClickAddAdmin = () => {
  window.location.href = adminCreatePath();
};
</script>
